import React from 'react';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { FormComponentProps } from '../../AccountForm.meta';
import { TabWrapper } from '../../AccountForm.styles';
import { AccountDescription } from '../../components/AccountDescription/AccountDescription';
import { AccountEarmark } from '../../components/AccountEarmark/AccountEarmark';
import { AccountFees } from '../../components/AccountFees/AccountFees';
import { AccountTypeSelect } from '../../components/AccountTypeSelect/AccountTypeSelect';
import { AssetBucketing } from '../../components/AssetBucketing/AssetBucketing';
import { Balance } from '../../components/Balance/Balance';
import { BrokerOfRecord } from '../../components/BrokerOfRecord/BrokerOfRecord';
import { ContributionEndYearSelect } from '../../components/ContributionEndYearSelect/ContributionEndYearSelect';
import { ContributionStartYearSelect } from '../../components/ContributionStartYearSelect/ContributionStartYearSelect';
import { Contributions } from '../../components/Contributions/Contributions';
import { DistributionStrategySelect } from '../../components/DistributionStrategy/DistributionStrategySelect';
import { InstitutionNameInput } from '../../components/InstitutionNameInput/InstitutionNameInput';
import { IsSpouseSingleBeneficiary } from '../../components/IsSpouseSingleBeneficiary/IsSpouseSingleBeneficiary';
import { TabsContent } from '../../components/TabsContent/TabsContent';
import { ManagementStyle } from '../../components/ManagementStyle/ManagementStyle';
import { GrossEstateCheckbox } from '../../components/GrossEstateCheckbox/GrossEstateCheckbox';
import { BypassRothIRAIncomeLimits } from '../../components/BypassRothIRAIncomeLimits/BypassRothIRAIncomeLimits';
import { AccountNickname } from '../../components/AccountNickname/AccountNickname';
import { Liquidity } from '../../components/Liquidity/Liquidity';
import { AccountOwnership } from '../../components/AccountOwnership/AccountOwnership';

const Summary = () => {
  return (
    <TabWrapper>
      <AccountTypeSelect />
      <InstitutionNameInput />
      <AccountOwnership />
      <AccountDescription />
      <AccountNickname />
      <Balance label="Current Market Value" />
      <AccountEarmark />
      <Contributions />
      <GrossEstateCheckbox />
      <BypassRothIRAIncomeLimits />
      <BrokerOfRecord />
      <Liquidity />
      <ManagementStyle />
      <AssetBucketing />
    </TabWrapper>
  );
};

const AccountDetails = () => {
  return (
    <TabWrapper>
      <Box
        css={`
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        `}
      >
        <ContributionStartYearSelect />

        <ContributionEndYearSelect />
      </Box>

      <DistributionStrategySelect />
      <AccountFees />
      <IsSpouseSingleBeneficiary />
    </TabWrapper>
  );
};

export const TraditionalIRA = (props: FormComponentProps) => {
  return (
    <TabsContent
      {...props}
      tabs={[
        { name: 'Summary', Component: Summary },
        { name: 'Account Details', Component: AccountDetails },
      ]}
    />
  );
};
